import React from 'react';

/**
 * ProgressSteps — 4-step horizontal stepper for the consignment wizard.
 *
 * Props:
 *  - step: 1-indexed current step (1..4)
 *  - labels: array of 4 strings shown beneath the numbered circles
 */
const DEFAULT_LABELS = [
  'Upload Photos',
  'Artwork Details',
  'Signatures & Marks',
  'Contact Info',
];

const ProgressSteps = ({ step, labels = DEFAULT_LABELS }) => (
  <div className="mb-12" data-testid="consign-progress-steps">
    <div className="flex items-center justify-between mb-4">
      {[1, 2, 3, 4].map((num) => (
        <div key={num} className="flex items-center flex-1">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-colors ${
              step >= num
                ? 'border-black bg-black text-white'
                : 'border-neutral-300 text-neutral-400'
            }`}
            data-testid={`consign-step-circle-${num}`}
            data-active={step === num ? 'true' : 'false'}
            data-complete={step > num ? 'true' : 'false'}
          >
            {num}
          </div>
          {num < 4 && (
            <div
              className={`flex-1 h-0.5 mx-2 transition-colors ${
                step > num ? 'bg-black' : 'bg-neutral-300'
              }`}
            />
          )}
        </div>
      ))}
    </div>
    <div className="grid grid-cols-4 gap-2 text-xs text-center text-neutral-600">
      {labels.map((label, idx) => (
        <div key={label} data-testid={`consign-step-label-${idx + 1}`}>
          {label}
        </div>
      ))}
    </div>
  </div>
);

export default ProgressSteps;
